/**
 * Copyright ©2025 Drivepoint
 */

import {Maybe} from "@dp-types/Maybe";
import Template from "@utilities/template/Template";
import State from "./state/State";

export type ErrorItem = {
  code: string;
  detailed_message?: string;
  message: string;
};

export default class ErrorCodes {

  public static DEFAULT_ERROR_ITEM: ErrorItem = {code: "unknown_error", message: "An unknown error has occurred, code: ${code}"};

  public static _errorCodes: Record<string, ErrorItem> = {};

  static async init(): Promise<void> {
    State.register("global_config", ErrorCodes._onGlobalConfigChange);
  }

  public static getErrorForCode(code: string, data: any = {}): Maybe<ErrorItem> {
    const item = ErrorCodes._errorCodes?.[code];
    if (!item) { return; }
    if (item.message) { item.message = ErrorCodes._parseTemplate(item.message, {...data, code}); }
    if (item.detailed_message) { item.detailed_message = ErrorCodes._parseTemplate(item.detailed_message, {...data, code}); }
    return item;
  }

  public static parse(error: any): {message: string, detailMessage: string, code?: string} {
    if (!error) { return {message: "Unknown error.", detailMessage: "Unknown error."}; }
    if (typeof error.code !== "string") { return {message: error.message, detailMessage: error.message}; }
    const errorItem = ErrorCodes.getErrorForCode(error.code, error.data);
    return {
      message: errorItem?.message ?? error.message,
      detailMessage: errorItem?.detailed_message ?? errorItem?.message ?? error.message,
      code: error.code
    };
  }

  private static _parseTemplate(template: string, data: any = {}): string {
    try {
      return Template.parse(template, data);
    } catch (error: any) {
      logger.error(template, error.message);
      return template;
    }
  }

  private static _onGlobalConfigChange(event: any): void {
    ErrorCodes._errorCodes = event.value?.error_codes ?? {};
  }

}
